module.exports = __webpack_public_path__ + "img/icon2.f73bc494.png";